import { variants } from './style.css.js';
import { jsx } from 'react/jsx-runtime';
const variantMap = {
  small: "horizontal-small",
  large: "horizontal-large",
  verticalSmall: "vertical-small"
};

const Divider = ({
  props,
  variant = "small",
  className
}) => {
  const variantKey = variantMap[variant];
  return /*#__PURE__*/jsx("div", {
    className: `${variants[variantKey]} ${className}`,
    ...props
  });
};

Divider.displayName = "Divider";
export { Divider };
